import React, { useEffect, useState } from "react";
import purchaseService from "../Services/purchaseService";
import { useLoaderData, useLocation } from "react-router-dom";
import moment from "moment";
import SupplierDebit from "../Modals/SupplierDebit";
import Loading from "../Modals/Loading";
import PayableService from "../Services/payableService";

const SupplierLedger = () => {
  const [Ledger, setLedger] = useState([]);
  const [supplier, setSupplier] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");
  const [trigger, setTrigger] = useState(false);
  const [payables, setPayables] = useState([]);

  const OpenModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const getPayables = async () => {
    try {
      const response = await PayableService.fetchBySupplier(params.get("id"));
      setPayables(response.payables);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPayables();
  }, []);

  useEffect(() => {
    const getCustomerLedger = async () => {
      try {
        setLoading(true);
        const response = await purchaseService.fetchSupplierLedger(
          params.get("id")
        );
        setSupplier(response.supplier);
        setLedger(response.ledger);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching customer ledger:", error);
        setLoading(false);
      }
    };
    getCustomerLedger();
  }, [trigger]);

  useEffect(() => {
    const getCustomerLedgerByDate = async () => {
      try {
        setLoading(true);
        const response = await purchaseService.fetchSupplierLedgerByDate(
          params.get("id"),
          {
            start_date,
            end_date,
          }
        );
        setSupplier(response.supplier);
        setLedger(response.ledger);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching customer ledger:", error);
        setLoading(false);
      }
    };
    if (start_date && end_date) {
      getCustomerLedgerByDate();
    }
  }, [start_date, end_date]);

  let totalDebit = 0;
  let totalCredit = 0;
  let finalBalance = 0;

  Ledger.forEach((entry) => {
    const amount = parseFloat(entry.amount) || 0;
    const balance = parseFloat(entry.balance) || 0;

    if (entry.type === "TRANSACTION") {
      totalDebit += amount;
    } else if (entry.type === "ORDER") {
      totalCredit += amount;
    }

    finalBalance = balance; // finalBalance will end up being the last entry's balance
  });

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      {loading ? (
        <div>
          <Loading />
        </div>
      ) : (
        <div>
          <p className="font-bold text-3xl text-secondary">Supplier Ledger</p>
          {supplier && (
            <div className="mt-10">
              <div className="bg-gray-100 px-8 py-4 mt-2 rounded-3xl">
                <div className="flex flex-col">
                  <div className="flex flex-row items-center gap-2">
                    <h6 className="text-primary text-2xl font-bold">
                      {supplier.company}
                    </h6>
                    <h6 className="text-md text-gray-500 bg-white px-4 p-[4px] rounded-lg">
                      {supplier.name}
                    </h6>
                  </div>
                  <div className="flex flex-row items-center gap-1 mt-4">
                    <h6 className="text-xl font-semibold text-gray-700">
                      {supplier.address}
                    </h6>
                    <h6 className="text-md text-gray-500">
                      ({supplier.country}){" "}
                    </h6>
                  </div>
                </div>
              </div>

              <div className="flex flex-row items-end justify-between mt-10">
                <div className="flex flex-row gap-8">
                  <div className="flex flex-col gap-1">
                    <label className="text-xs text-primary font-bold">
                      Start Date
                    </label>
                    <input
                      type="date"
                      name="start_date"
                      onChange={(e) => {
                        setStartDate(e.target.value);
                      }}
                      className="primary-input"
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="text-xs text-primary font-bold">
                      End Date
                    </label>
                    <input
                      type="date"
                      name="end_date"
                      onChange={(e) => {
                        setEndDate(e.target.value);
                      }}
                      className="primary-input"
                    />
                  </div>
                </div>
                <button className="button-primary" onClick={() => OpenModal()}>
                  Add Payment
                </button>
              </div>

              <div className="table-div">
                <table>
                  <thead>
                    <tr className="border-y-2 text-left w-full text-black text-[10px]">
                      <th className="py-3 pl-4 w-[1%]">Date</th>
                      <th className="py-3 pl-4 w-[2%]">Reference</th>
                      <th className="py-3 pl-4 w-[2%]">Note</th>
                      <th className="py-3 pl-4 w-[1%]">Credit</th>
                      <th className="py-3 pl-4 w-[1%]">Debit</th>
                      <th className="py-3 pl-4 w-[1%]">Balance</th>
                    </tr>
                  </thead>

                  <tbody>
                    {Ledger?.map((entry, index) => (
                      <tr
                        key={index}
                        className={`border-b border-gray-100 text-left ${
                          index % 2 === 0 ? "bg-gray-100" : "bg-accent"
                        } `}
                      >
                        <td className="py-3 pl-4 text-primary font-bold w-[1%]">
                          {entry.purchase_date
                            ? moment(entry.purchase_date).format("ll")
                            : moment(entry.date).format("ll")}
                        </td>
                        <td className="py-3 pl-4 text-gray-700 font-light w-[2%]">
                          {entry.type === "ORDER"
                            ? `Order ${entry.id}`
                            : `Payment for Order ${entry.purchase_id}`}
                        </td>
                        <td className="py-3 pl-4 text-gray-700 font-light w-[2%]">
                          {entry.note ? entry.note : "-"}
                        </td>
                        <td className="py-3 pl-4 font-medium w-[1%]">
                          {entry.type === "ORDER" ? entry.amount : "-"}
                        </td>
                        <td className="py-3 pl-4 font-medium w-[1%]">
                          {entry.type === "TRANSACTION" ? entry.amount : "-"}
                        </td>
                        <td className="py-3 pl-4 font-light w-[1%]">
                          {parseFloat(entry.balance).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                    <tr className="text-[14px] bg-slate-200 font-semibold text-teal-600">
                      <td colSpan={3} className="py-3 pl-4">
                        Total
                      </td>
                      <td className="py-3 pl-4">{totalCredit.toFixed(2)}</td>
                      <td className="py-3 pl-4">{totalDebit.toFixed(2)}</td>
                      <td className="py-3 pl-4">{finalBalance.toFixed(2)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {payables && payables.length > 0 && (
                <div className="mt-6">
                  <table>
                    <caption className="font-bold text-2xl mb-2">
                      Payables
                    </caption>
                    <thead className="bg-primary">
                      <tr className=" uppercase leading-normal w-full text-center text-[12px] text-white">
                        <th className="py-3 pl-5 w-[4%] rounded-tl-lg">
                          Supplier Name
                        </th>
                        <th className="py-3 pl-5 w-[3%] ">Cheque No</th>
                        <th className="py-3 pl-5 w-[2%]">Bank Name</th>
                        <th className="py-3 pl-5 w-[2%]">Amount</th>
                        <th className="py-3 pl-5 w-[4%]">Presentable Date</th>
                        <th className="py-3 pl-5 w-[4%] rounded-tr-lg">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {payables.map((value, index) => (
                        <tr
                          key={index}
                          className="bg-accent hover:bg-gray-100 duration-300 text-center text-[12px] border-b border-primary border-opacity-25"
                        >
                          <td className="py-3 w-[2%]">{value.supplier_name}</td>
                          <td className="py-3 w-[3%]">{value.number}</td>
                          <td className="py-3 w-[3%]">{value.bank}</td>
                          <td className="py-3 w-[3%]">{value.amount}</td>
                          <td className="py-3 w-[3%]">{value.payable}</td>
                          <td className="py-3 w-[3%]">
                            <p
                              className={`${
                                value.status === "CLEARED"
                                  ? "bg-green-500"
                                  : "bg-red-500"
                              } text-center rounded-md text-white uppercase`}
                            >
                              {value.status}
                            </p>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <div className="flex flex-row items-center justify-end gap-4 mt-3">
                <div className="bg-gray-100 flex flex-row gap-2 px-4 py-2 rounded-md">
                  <p className="text-xl font-bold text-gray-600">
                    End Balance:
                  </p>
                  <p className="text-xl font-bold text-teal-600">
                    {parseFloat(Ledger[Ledger.length - 1]?.balance)?.toFixed(2)}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <SupplierDebit
        isOpen={isModalOpen}
        onClose={closeModal}
        supplier={params.get("id")}
        // trigger={trigger}
        // setTrigger={setTrigger}
      />
    </main>
  );
};

export default SupplierLedger;
